
/**
 * Converter timestamp para uma data normalizada
 * @example
 * timestampToDate('2019-12-01 00:00:00')
 * //=> '2019-12-1'
 */
const timestampToDate = (timestamp) => {
  const safeTimestamp = `${timestamp || ''}`
  const match = safeTimestamp.match(/(\d{4})-(\d{1,2})-(\d{1,2})/)

  if (!match) {
    return ''
  }

  const [ , year, month, day ] = match

  return [
    year,
    month.padStart(2, '0'),
    day.padStart(2, '0')
  ].join('-')
}

const dateToUTC = (date) => {
  const [ year, month, day ] = date
    .split('-')
    .map(x => Number(x))

  return Date.UTC(year, month - 1, day)
}

/**
 * Verificar se uma data está entre duas datas (inicial e final)
 *
 * @params {string} date Data para verificar
 * @params {string} di Data inicial
 * @params {string} df Data final
 * @returns {boolean} Resultado da verificação
 * @examples
 * checkDate('1999-09-14', '1999-09-13', '1999-09-15')
 * //=> true
 * checkDate('1999-09-14', '2000-01-01', '2000-12-01')
 * //=> false
 */
export default (date, di, df) => {
  date = timestampToDate(date)
  di = timestampToDate(di)
  df = timestampToDate(df)

  if (!date || !di || !df) {
    return false
  }

  const timeDate = dateToUTC(date)
  const timeDi = dateToUTC(di)
  const timeDf = dateToUTC(df)

  return timeDate >= timeDi && timeDate <= timeDf
}
